import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import { AiOutlineArrowUp } from "react-icons/ai";
import CallIcon from "@mui/icons-material/Call";
import "./footer.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Logo from '../../../assets/Logo/logo.svg'

//social media links:
const logolab_facebook =
  "https://www.facebook.com/profile.php?id=100063752927822";

const Footer = () => {
  const phoneNumber = 9765978888;

  const handleCallClick = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  useEffect(() => {
    Aos.init();
    Aos.refresh();
  }, []);

  return (
    <div className="main_footer sticky z-10">
      <h1 className="footer_title" data-aos="fade-up" data-aos-duration="1000">
        Let's Work Together
      </h1>
      <div
        className="footer_button_box"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <button className="footer_btn" onClick={handleCallClick}>
          <CallIcon className="call_icon" />
          Call Now
        </button>

        <div className="footer_whatsapp_btn_container">
          <a
            style={{ padding: "1rem 1.25rem" }}
            href="https://wa.me/9765978888"
            className="footer_main_btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsAppIcon className="whatsapp_icon" />
            WhatsApp Us
          </a>
        </div>
      </div>
      <hr className="hr_line" />
      <div className="footer_content">
        <div className="footer_left">
          <div className="footer_map_and_adresses">
            <div className="footer_left_address_maps">
              <div className="footer_logo_left">
                <img src="logo.png" alt="logo" width={200} />
              </div>
              <p className="footer_address">
                {/* <MdLocationPin className="location_icon" size={24} /> */}
                <span>Kathmandu,</span> <br />
                <span className="samakhushi_margin">Uttar Dhoka, Lazimpat</span>
              </p>
            </div>
            {/* <div className="footer_map_area">
              <img
                className="ktm_google_map_img"
                src="ktm_map.jpg"
                alt="googleMap"
              />
              <a
                className="open_map"
                href="https://goo.gl/maps/GYVdWWdbGfb9h5k9A"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click For Map
              </a>
            </div> */}
          </div>
        </div>
        <div className="footer_mid">
          <h2>Quick Links</h2>
          <Link to="/">Home</Link>
          <Link to="/works">Our Works</Link>
          {/* <Link to="/blogs">Blogs</Link>
          <Link to="/services">Services</Link> */}
          {/* <a href="/">Our Services</a>
          <a href="/">Case Studies</a> */}
        </div>
        <div className="footer_right">
          <h3>Find us at</h3>
          <div className="find_us_links_container">
            <a
              href={logolab_facebook}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2rem"
                height="2rem"
                viewBox="0 0 24 24"
              >
                <rect width="24" height="24" fill="none" />
                <path
                  fill="white"
                  d="M17 3.5a.5.5 0 0 0-.5-.5H14a4.77 4.77 0 0 0-5 4.5v2.7H6.5a.5.5 0 0 0-.5.5v2.6a.5.5 0 0 0 .5.5H9v6.7a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-6.7h2.62a.5.5 0 0 0 .49-.37l.72-2.6a.5.5 0 0 0-.48-.63H13V7.5a1 1 0 0 1 1-.9h2.5a.5.5 0 0 0 .5-.5Z"
                />
              </svg>
            </a>
            <a
              href="https://instagram.com/logolabnepal"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2rem"
                height="2rem"
                viewBox="0 0 24 24"
              >
                <rect width="24" height="24" fill="none" />
                <path
                  fill="white"
                  d="M13.028 2c1.125.003 1.696.009 2.189.023l.194.007c.224.008.445.018.712.03c1.064.05 1.79.218 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.012.266.022.487.03.712l.006.194c.015.492.021 1.063.023 2.188l.001.746v1.31a79 79 0 0 1-.023 2.188l-.006.194c-.008.225-.018.446-.03.712c-.05 1.065-.22 1.79-.466 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465l-.712.03l-.194.006c-.493.014-1.064.021-2.189.023l-.746.001h-1.309a78 78 0 0 1-2.189-.023l-.194-.006a63 63 0 0 1-.712-.031c-1.064-.05-1.79-.218-2.428-.465a4.9 4.9 0 0 1-1.771-1.153a4.9 4.9 0 0 1-1.154-1.772c-.247-.637-.415-1.363-.465-2.428l-.03-.712l-.005-.194A79 79 0 0 1 2 13.028v-2.056a79 79 0 0 1 .022-2.188l.007-.194c.008-.225.018-.446.03-.712c.05-1.065.218-1.79.465-2.428A4.9 4.9 0 0 1 3.68 3.678a4.9 4.9 0 0 1 1.77-1.153c.638-.247 1.363-.415 2.428-.465c.266-.012.488-.022.712-.03l.194-.006a79 79 0 0 1 2.188-.023zM12 7a5 5 0 1 0 0 10a5 5 0 0 0 0-10m0 2a3 3 0 1 1 .001 6a3 3 0 0 1 0-6m5.25-3.5a1.25 1.25 0 0 0 0 2.5a1.25 1.25 0 0 0 0-2.5"
                />
              </svg>
            </a>
            <a
              href="https://linkedin.com/company/logolabnepal"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2rem"
                height="2rem"
                viewBox="0 0 24 24"
              >
                <rect width="24" height="24" fill="none" />
                <path
                  fill="white"
                  d="M4.75 1.875a2.125 2.125 0 1 0 0 4.25a2.125 2.125 0 0 0 0-4.25m-2 6A.125.125 0 0 0 2.625 8v13c0 .069.056.125.125.125h4A.125.125 0 0 0 6.875 21V8a.125.125 0 0 0-.125-.125zm6.5 0A.125.125 0 0 0 9.125 8v13c0 .069.056.125.125.125h4a.125.125 0 0 0 .125-.125v-7a1.875 1.875 0 1 1 3.75 0v7c0 .069.056.125.125.125h4a.125.125 0 0 0 .125-.125v-8.62c0-2.427-2.11-4.325-4.525-4.106a7.2 7.2 0 0 0-2.169.548l-1.306.56V8a.125.125 0 0 0-.125-.125z"
                />
              </svg>
            </a>
            <a
              href="https://wa.me/9765978888"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2rem"
                height="2rem"
                viewBox="0 0 24 24"
              >
                <rect width="24" height="24" fill="none" />
                <path
                  fill="white"
                  d="M13.794 2.642c4.68.9 7.86 4.954 7.7 9.773c-.147 4.444-3.742 8.318-8.27 8.873a9.55 9.55 0 0 1-5.318-.86a1.37 1.37 0 0 0-.84-.082c-1.356.325-2.701.694-4.05 1.045c-.148.038-.3.064-.516.109c.405-1.482.783-2.904 1.187-4.32c.103-.358.074-.644-.091-.995c-1.575-3.345-1.438-6.627.708-9.66c2.151-3.042 5.187-4.34 8.92-3.96c.176.017.351.042.57.077m5.914 11.004c.268-1.096.3-2.207.038-3.298c-.788-3.288-2.834-5.419-6.16-6.093c-3.263-.66-6.003.44-7.936 3.138c-1.936 2.702-1.978 5.6-.38 8.503c.205.373.26.68.135 1.078c-.228.728-.405 1.472-.628 2.298c.925-.24 1.736-.47 2.558-.65c.233-.051.538-.024.742.088c4.696 2.585 10.277.2 11.63-5.064"
                />
                <path
                  fill="white"
                  d="M9.745 8.158c.179.427.3.84.51 1.203c.3.518.209.953-.205 1.318c-.445.392-.379.725-.06 1.175c.735 1.036 1.658 1.813 2.823 2.322c.32.14.563.164.77-.157c.086-.132.206-.24.306-.364c.583-.726.4-.72 1.324-.319c.291.127.582.262.851.428c.27.165.68.335.732.57c.118.52-.048 1.048-.482 1.434c-.8.712-1.72.83-2.725.552c-2.174-.6-3.846-1.904-5.127-3.71c-.452-.637-.856-1.344-1.11-2.078c-.308-.894-.09-1.756.546-2.513c.375-.445.83-.545 1.325-.426c.199.048.338.344.522.565"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="footer_header">
        <div className="flex justify-end text-sm lg:gap-[55rem] gap-[1rem]">
          <p className="">
            &#169; Copyright {(new Date().getFullYear())}. All Right Reserved{" "}
            </p>
            <a target="_blank" rel="noreferrer" href="https://webxnep.com" className="flex items-center">
              Designed & Developed By <img src={Logo} alt="webX Logo" className="h-6 w-20 ml-1" />
            </a>
          
        </div>
        {/* <a className="goUp" href="#navbar">
          <AiOutlineArrowUp color="white" size={20} />
        </a> */}
      </div>
    </div>
  );
};

export default Footer;
